export default "https://cdn-static.gokick.com/assets/94c0a6f1f1290e979b6f5177b757303844c3d722/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";